import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import Dropdown from "../../../../../common/Dropdown";

const styles = (theme) => ({
  label: {
    display: "flex",
    alignItems: "baseline",
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    paddingBottom: 12,
    lineHeight: "16px",
    paddingLeft: 20,
  },
  valueContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: 12,
    "&>div": {
      flex: 1,
      width: "100%",
    },
    paddingLeft: 20,
  },
  valueText: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
  },
  error:{
    fontSize:12,
    color: theme.errorBorderColor,
  }
});

const DispatchInput = (props) => {
  const { classes, label, value, disableEdit, ...others } = props;

  const renderError = () => others.error ? (
    <div className={classes.error}>{others.error}</div>
  ) : null
  
  return (
    <Grid container>
      <Grid item xs={4} className={classes.label}>
        {label}
      </Grid>
      <Grid item xs={6} className={classes.valueContainer}>
        {disableEdit ? (
          <>
            <div className={classes.valueText}>{value}</div>
            {renderError()}
          </>
        ) : (
          <Dropdown value={value} {...others} />
        )}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(DispatchInput);
